import React from "react";
import Resources from "../../../types/Resources";
import LabelCheckbox from "../../Common/LabelCheckbox";
import ProtectiveEquipmentFormState from "../../../types/forms/Permits/Conditions/ProtectiveEquipmentFormState";
import GasWarnerFormState from "../../../types/forms/Permits/Conditions/GasWarnerFormState";

type ProtectiveEquipmentProps = {
    resources: Resources;
    formState: ProtectiveEquipmentFormState;
    onChange: (fn: (prevValue: ProtectiveEquipmentFormState) => ProtectiveEquipmentFormState) => void;
    canManageContent: boolean;
};

function ProtectiveEquipment({ resources, formState, onChange, canManageContent }: ProtectiveEquipmentProps) {
    function changeHandler(key: keyof ProtectiveEquipmentFormState, value: any) {
        onChange((prevValue) => {
            const updatedFormState: ProtectiveEquipmentFormState = {
                ...prevValue,
                [key]: { ...prevValue[key], value }
            };

            return updatedFormState;
        });
    }

    function gasWarnerChangeHandler(key: keyof GasWarnerFormState, value: any) {
        onChange((prevValue) => {
            const updatedFormState: ProtectiveEquipmentFormState = {
                ...prevValue,
                gasWarner: {
                    ...prevValue.gasWarner,
                    [key]: { ...prevValue.gasWarner[key], value }
                }
            };

            return updatedFormState;
        });
    }

    return (
        <>
            <h1 className="h6">{resources.get("ProtectiveEquipmentAndEducations")}</h1>
            <ul className="list-unstyled">
                <li className="m-2">
                    <LabelCheckbox
                        id="using-life-jacket"
                        checked={formState.usingLifeJacket.value}
                        label={resources.get("UsingLifeJacket")}
                        onChange={(checked) => changeHandler("usingLifeJacket", checked)}
                        readOnly={!canManageContent}
                    />
                </li>
                <li className="m-2">
                    <LabelCheckbox
                        id="using-helmet"
                        checked={formState.usingHelmet.value}
                        label={resources.get("UsingHelmet")}
                        onChange={(checked) => changeHandler("usingHelmet", checked)}
                        readOnly={!canManageContent}
                    />
                </li>
                <li className="m-2">
                    <LabelCheckbox
                        id="using-protective-glasses"
                        checked={formState.usingProtectiveGlasses.value}
                        label={resources.get("UsingProtectiveGlasses")}
                        onChange={(checked) => changeHandler("usingProtectiveGlasses", checked)}
                        readOnly={!canManageContent}
                    />
                </li>
                <li className="m-2">
                    <LabelCheckbox
                        id="personal-gas-warner"
                        checked={formState.gasWarner.personalGasWarner.value}
                        label={resources.get("PersonalGasWarner")}
                        onChange={(checked) => gasWarnerChangeHandler("personalGasWarner", checked)}
                        readOnly={!canManageContent}
                        containerClassName="d-inline"
                    />
                    <div className="d-inline ms-4">
                        <LabelCheckbox
                            checked={formState.gasWarner.forLEL.value}
                            id="for-LEL"
                            label={resources.get("ForLEL")}
                            onChange={(checked) => gasWarnerChangeHandler("forLEL", checked)}
                            readOnly={!canManageContent}
                            containerClassName="form-check-inline"
                        />
                        <LabelCheckbox
                            id="for-H2S"
                            checked={formState.gasWarner.forH2S.value}
                            label={resources.get("ForH2S")}
                            onChange={(checked) => gasWarnerChangeHandler("forH2S", checked)}
                            readOnly={!canManageContent}
                            containerClassName="form-check-inline"
                        />
                        <LabelCheckbox
                            id="for-O2"
                            checked={formState.gasWarner.forO2.value}
                            label={resources.get("ForO2")}
                            onChange={(checked) => gasWarnerChangeHandler("forO2", checked)}
                            readOnly={!canManageContent}
                            containerClassName="form-check-inline"
                        />
                    </div>
                </li>
                <li className="m-2">
                    <LabelCheckbox
                        id="using-gas-mask"
                        checked={formState.usingGasMask.value}
                        label={resources.get("UsingGasMask")}
                        onChange={(checked) => changeHandler("usingGasMask", checked)}
                        readOnly={!canManageContent}
                    />
                </li>
                <li className="m-2">
                    <LabelCheckbox
                        id="using-fresh-air-mask"
                        checked={formState.usingFreshAirMask.value}
                        label={resources.get("UsingFreshAirMask")}
                        onChange={(checked) => changeHandler("usingFreshAirMask", checked)}
                        readOnly={!canManageContent}
                    />
                </li>
                <li className="m-2 d-flex">
                    <label className="me-2" htmlFor="protective-equipment-other">
                        {resources.get("Other")}
                    </label>
                    <input
                        type="text"
                        className={`form-control ${!canManageContent ? "read-only-input" : ""}`}
                        value={formState.other.value ?? ""}
                        onChange={(e) => changeHandler("other", e.target.value)}
                        readOnly={!canManageContent}
                    />
                </li>
            </ul>
        </>
    );
}

export default ProtectiveEquipment;
